import 'css-chunksrc/client/pages/milestonePage/milestoneCompletion/styles.scss';export default {
  "milestoneCompletion": "_milestoneCompletion_11e4a_1",
  "icon": "_icon_11e4a_8",
  "completed": "_completed_11e4a_16",
  "input": "_input_11e4a_20",
  "listRoot": "_listRoot_11e4a_36",
  "list": "_list_11e4a_36",
  "item": "_item_11e4a_56",
  "name": "_name_11e4a_61",
  "doneName": "_doneName_11e4a_67",
  "open": "_open_11e4a_71",
  "done": "_done_11e4a_67",
  "readOnly": "_readOnly_11e4a_89"
};